import React, { useState } from 'react';
import { User, GraduationCap, ChevronRight } from 'lucide-react';
import OnboardingLayout from './OnboardingLayout';
import { Link } from 'react-router-dom';

const WelcomeSteps = () => {
  // 1. Initialize state to track the active step (defaulting to step 1)
  const [activeStep, setActiveStep] = useState(1);

  return (
    <OnboardingLayout>
      <h2 className="fw-bold text-dark">Welcome</h2>
      <p className="text-muted small mb-4">Let's get you set up.</p>

      <div className="vstack gap-3 mb-5">
        
        {/* Step 1: Profile */}
        <div 
          onClick={() => setActiveStep(1)}
          className={`step-item p-3 d-flex align-items-center cursor-pointer transition-all ${
            activeStep === 1 ? 'active shadow-sm' : 'border opacity-50'
          }`}
          style={{ cursor: 'pointer' }}
        >
          <div className={`p-3 rounded-5 shadow-sm me-3 border ${
            activeStep === 1 ? 'bg-white text-primary' : 'bg-light text-muted'
          }`}>
            <User size={20} />
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold small">Profile</div>
            <div className="text-muted" style={{fontSize: '0.8rem'}}>Set up your personal details.</div>
          </div>
          {activeStep === 1 ? (
            <span className="badge text-primary bg-primary-subtle rounded-pill">STEP 1</span>
          ) : (
            <span className="text-muted small fw-bold">STEP 1</span>
          )}
        </div>

        {/* Step 2: Tracks */}
        <div 
          onClick={() => setActiveStep(2)}
          className={`step-item p-3 d-flex align-items-center cursor-pointer transition-all ${
            activeStep === 2 ? 'active shadow-sm' : 'border opacity-50'
          }`}
          style={{ cursor: 'pointer' }}
        >
          <div className={`p-3 rounded-5 shadow-sm me-3 border ${
            activeStep === 2 ? 'bg-white text-primary' : 'bg-light text-muted'
          }`}>
            <GraduationCap size={20} />
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold small">Tracks</div>
            <div className="text-muted" style={{fontSize: '0.8rem'}}>Discover your learning path.</div>
          </div>
          {activeStep === 2 ? (
            <span className="badge text-primary bg-primary-subtle rounded-pill">STEP 2</span>
          ) : (
            <span className="text-muted small fw-bold">STEP 2</span>
          )}
        </div>

      </div>

      <div className="d-flex flex-column flex-md-row gap-3">
        <Link to='/step-2' className="btn btn-ieee-primary flex-grow-1 d-flex align-items-center justify-content-center">
          Get Started <ChevronRight size={18} className="ms-2" />
        </Link>
        <button className="btn btn-link text-decoration-none text-muted fw-bold small">Skip for now</button>
      </div>
    </OnboardingLayout>
  );
};

export default WelcomeSteps;